import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { OktaAuthService } from '@okta/okta-angular';

@Injectable()
export class AuthGuard implements CanActivate {
  //Okta variables
  isAuthenticated: boolean;

  constructor(
    private router: Router,
    public oktaAuth: OktaAuthService
  ) { }


  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.isAuthenticated = await this.oktaAuth.isAuthenticated();
    console.log(`Autheniticated?: ${this.isAuthenticated}`)
    try {
      if (localStorage.getItem('currentUser') && this.isAuthenticated) {
        // logged in so return true
        return true;
      } else {
        // not logged in so redirect to login page with the return url
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
      }

    } catch (err) {
      console.log(err);
      this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
      return false;
    }

  }
}
